//import liraries
import React  from "react";
import { View, Modal, TouchableOpacity, StyleSheet, Image} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles'
import CustomButton from "./CustomButton";
import CImage from "./CImage";
import { COLORS } from "../constant";
import CText from "./CText";
import RootNavigation from "../utilities/RootNavigation";

// create a component
const CWelcomeModalTagClosure = ({ visible, onCloseModal, vehicleList }) => {
  const styles = useStyles();
  const tagClosedByNpci = vehicleList.filter(item=>{return item.status == "Closed by NPCI"})
  const tagsMarkedForClosure = vehicleList.filter(item=>{return item.status == "NPCI LB"})
  
  let headingText = ""
  let description = ""
  let closeButtonText = ""
  let knowMoreButtonDisplay = false

  if(tagClosedByNpci?.length > 0 && tagsMarkedForClosure?.length>0 ){
    headingText = "Some of your FASTags have been marked for closure/have been forcefully closed"
    description = "As per the government’s One Vehicle, One FASTag Policy, some of your tags have been marked for closure/have been closed by NPCI since multiple bank tags were linked to your vehicle. Please close your tags within next 7 days."
    closeButtonText = "Close FASTag marked for closure"
    knowMoreButtonDisplay = true
  }else if(tagClosedByNpci?.length == 0 && tagsMarkedForClosure?.length > 0){
    closeButtonText = "Close FASTag"
    headingText = "One of your FASTag has been marked for closure"
    description = "As per the government’s One Vehicle, One FASTag Policy, One or more of your FASTags have been marked for closure by NPCI since multiple bank tags are linked to your vehicle(s). Please close your tag within the next 7 days."
  }else if(tagClosedByNpci?.length > 0 && tagsMarkedForClosure?.length == 0){
    closeButtonText = "Know more"
    headingText = "One of your FASTag has been closed by NPCI"
    description = "As per the government’s policy of One Vehicle, One FASTag, Your Tag XXXXXXXXXXX13 on Vehicle MHXX2XXXX was closed since multiple bank tags were linked to the above vehicle."
  }

  const onPressBanner = () =>{
    RootNavigation.navigate("ServiceRequest/SelectVehicleForTagClosure",{isForcefulTagClosure : true,vehicleList :vehicleList})
  }
  return (
    <Modal
      animationType={"fade"}
      visible={true}
      transparent={true}
      onRequestClose={() => onCloseModal()}
    >
     <TouchableOpacity style={styles.overlayContainer} onPress={() => onCloseModal()} >
        <View style={styles.overlay}></View>
        <View style={styles.modalContainer}>
          <View style={styles.modalBody}>
            <TouchableOpacity style={styles.closeBtnWidget} onPress={() => onCloseModal()}>
              <CImage.CloseIcon1></CImage.CloseIcon1>
            </TouchableOpacity>
            <View style={{backgroundImage: "linear-gradient(270deg, #d14a27 0%, #e89b61 100%)", width:330, padding:15, borderRadius:6}}>
              <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center',marginBottom:8}}>
                <CImage.WarningSignIcon ></CImage.WarningSignIcon>
                <CText.welcomeModalTitle style={{marginLeft:10}}>{headingText}</CText.welcomeModalTitle>
              </View>
              <CText.welcomeModalDesc>{description}</CText.welcomeModalDesc>
              <View style={styles.btnWidget}>
              <CustomButton
                onPress={() => onPressBanner()}
                color ="gray"
                style={{backgroundColor:"white", borderRadius:15, alignItems:'center',width:'100%',paddingVertical:8,fontSize:10,marginTop:5}}
                text={closeButtonText}
              />
              {knowMoreButtonDisplay && 
              <CustomButton
                onPress={() => onPressBanner()}
                style={{borderColor:COLORS.white, borderRadius:15,borderWidth:1, alignItems:'center',width:'100%',paddingVertical:8,fontSize:10,marginTop:5}}
                text={"Know more about closed tag"}
              /> }
            </View>
            </View>
            
           
          </View>
          
        </View>
        </TouchableOpacity>
      
    </Modal>
  );
};

export default CWelcomeModalTagClosure;

const useStyles = CreateResponsiveStyle(
  {
    overlayContainer: {
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.7)",
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      zIndex: 99,
    },
    modalContainer: {
      height: "100%",
      width: "100%",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
      zIndex:999
    },
    modalBody: {
      width: "90%",
      height: "100%",
      alignSelf: "center",
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    },
    imageStyle:{ 
      width: 450,
      height: 450, 
      borderRadius: 10, 
      margin: 0, 
      padding: 0,
      alignSelf:'center', 
    },
    btnWidget:{
      width:300,
      marginTop:15,
    },
    closeBtnWidget:{
      marginLeft:455
    }
   
   
  },

  {
    [DEVICE_SIZES.LG]: {
      

    },
    [DEVICE_SIZES.MD]: {
      
    },
    [DEVICE_SIZES.SM]: {
      
      imageStyle:{ 
        width: 320,
        height: 320, 
      },
      btnWidget:{
        width:300,
      },
      closeBtnWidget:{
        marginLeft:325
      }
    },
    [DEVICE_SIZES.XS]: {
      btnWidget:{
        width:280,
      },
      imageStyle:{ 
        width: 250,
        height: 250,
      },
      closeBtnWidget:{
        marginLeft:255
      }

    },
  }
);

const styles = StyleSheet.create({
  
});

